// ? NOTES: These are palettes from PMS

const colors = {
  primary: {
    100: '#EFF0FF',
    200: '#C6C9FF',
    300: '#878EFF',
    400: '#525DFF',
    500: '#312DFF',
    600: '#2420CC',
    700: '#1A187D',
    800: '#0F0E42',
  },
  yellow: {
    pale: '#FFF2C6',
    dark: '#A58410',
  },
  green: {
    pale: '#D4E6CC',
  },
  alert: {
    deletedBg: '#CE3504',
    succeedBg: '#298000',
    succeedBgLight: '#DEF2D5',
    warningBg: '#FFD02B',
    warningBgLight: '#FCF4D8',
    warningIcon: '#DB7600',
    greyBg: '#565768',
  },
  error: {
    error: '#CE3504',
    errorShade: '#B92D00',
    errorbg: '#FEE1DD',
  },
  neutrals: {
    greyDisabled: '#CAD0DD',
    grey: '#9E9FBF',
    greyTableBorder: '#DCE2F2',
    greybg: '#F8F9FB',
    black: '#2C2C2C',
    white: '#FFFFFF',
    hawkesBlue: '#D5DDEA',
    aliceBlue: '#FDFEFF',
    solitude: '#ECF0F5',
    greyDark: '#69697A',
    yellow: '#FFD815',
    lightYellow: '#FCF4D8',
    lightGrey: '#102A43',
  },
  azure: {
    100: '#D7EFFF',
    200: '#9AD8FE',
    300: '#5DC0FD',
    400: '#10A3FD',
    500: '#028ADE',
    600: '#0271B6',
    700: '#01588D',
  },
  bookingRequestStatus: {
    cancelledText: '#8C8DAF',
    waitingApprovalText: '#DB7600',
  },
  bookingStatus: {
    confirmedBg: '#ECF9E6',
    confirmedText: '#0F5C20',
    inHouseBg: '#E0EDFF',
    inHouseText: '#052494',
    checkedOutBg: '#ECEFF8',
    checkedOutText: '#42426C',
    noShowBg: '#FBE9EA',
    noShowText: '#961D1F',
    archivedBg: '#CAD0DD',
    archivedText: '#2C2C2C',
    waitingApprovalBg: '#FCF4D8',
    waitingApprovalText: '#DB7600',
    requestCancelBg: '#EFF0FF',
    requestCancelText: '#2C2C2C',
    rejectedBg: '#FEE1DD',
    rejectedText: '#CE3504',
    agentCancelledBg: '#F8F9FB',
    agentCancelledText: '#8C8DAF',
  },
  paymentStatus: {
    pendingPaymentBg: '#FFE1E3',
    pendingPaymentText: '#D50A0A',
    waitingPaymentBg: '#FFF2C6',
    waitingPaymentText: '#DB7600',
    partiallyPaidBg: '#F6F5FF',
    partiallyPaidText: '#4E1DAF',
    paidBg: '#E6F7F9',
    paidText: '#0A4E5C',
    unpaidBg: '#FFE1E3',
    unpaidText: '#D50A0A',
    waitingPaymentNewText: '#BC7100',
    failedBg: '#FEE1DD',
    failedText: '#CE3504',
  },
  rates: {
    addOn: {
      magenta: '#F4E0FF',
    },
    packageBg: '#F6FDFF',
    packageText: '#002BAE',
  },
}

export default colors
